import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "tenant-details",
  class: "d-flex flex-fill edit-page-40"
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "edit-header" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = {
  class: "card-body overflow-auto",
  id: "card-body"
}
const _hoisted_6 = { id: "tenant-draft" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = {
  id: "connector-table",
  class: "mt-2"
}
const _hoisted_11 = { class: "pagination-wrapper" }
const _hoisted_12 = { class: "card-footer footer" }
const _hoisted_13 = { class: "float-right" }

import { computed, onBeforeMount, ref } from "vue";
import { cloneDeep } from "lodash-es";
import { ElTable, ElTableColumn, ElButton, ElPagination } from "element-plus";
import { getTenant } from "@/tenant/services/tenant.service";
import { currentRoute, router } from "@/core/router";
import { hasPermission } from "@/core/auth";
import i18n from "@/core/i18n/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'TenantDetails',
  setup(__props) {

const { t } = i18n.global;
const tenant = ref({
  connectors: [],
  users: [],
});

const id = ref("");

const headerStyle = ref({
  color: "black",
  borderBottomColor: "#808080FF",
});

const perPageConnectors = ref(5);

const currentPageConnectors = ref(1);

const numberOfConnectors = computed(() =>
  tenant.value.connectors ? tenant.value.connectors.length : 0
);

const numberOfPagesConnectors = computed(() => {
  if (numberOfConnectors.value) {
    return Math.ceil(numberOfConnectors.value / perPageConnectors.value);
  }
  return 0;
});

const connectorTableData = computed(() => {
  if (tenant.value.connectors) {
    if (numberOfPagesConnectors.value === 1) {
      return tenant.value.connectors;
    }
    const start = (currentPageConnectors.value - 1) * perPageConnectors.value;
    const end = currentPageConnectors.value * perPageConnectors.value;
    return tenant.value.connectors.slice(start, end);
  }
  return [];
});

function convertDate(dateStr) {
  const milliseconds = Date.parse(dateStr);
  const date = new Date(milliseconds);
  return date.toLocaleDateString();
}

onBeforeMount(async () => {
  id.value = currentRoute.value.params.id as string;
  if (id.value) {
    await getTenant(id.value).then((response) => {
      if (response) {
        tenant.value = cloneDeep(response);
      }
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)("Organization.TenantDetails")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Name")) + ":", 1),
              _createTextVNode(" " + _toDisplayString(tenant.value.name), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.CreationTime")) + ":", 1),
              _createTextVNode(" " + _toDisplayString(convertDate(tenant.value.createdAt)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Connectors")), 1),
            _createVNode(_unref(ElTable), {
              data: connectorTableData.value,
              style: {"width":"100%"},
              "header-cell-style": headerStyle.value
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElTableColumn), {
                  label: "Name",
                  prop: "name",
                  width: "auto"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(ElTableColumn), {
                  label: "Spec Id",
                  prop: "specId",
                  width: "auto"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.connectorSpecId), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "header-cell-style"]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(ElPagination), {
                small: "",
                "page-size": perPageConnectors.value,
                style: {"width":"auto"},
                background: "",
                "hide-on-single-page": "",
                total: numberOfConnectors.value,
                "current-page": currentPageConnectors.value,
                "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPageConnectors).value = $event)),
                layout: "prev, pager, next"
              }, null, 8, ["page-size", "total", "current-page"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_unref(ElButton), {
            class: "btn-oneTeg3",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/tenants')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Common.Back")), 1)
            ]),
            _: 1
          }),
          (_unref(hasPermission)('TENANTS.LIST.EDIT'))
            ? (_openBlock(), _createBlock(_unref(ElButton), {
                key: 0,
                class: "btn-oneTeg2",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/tenants/edit/' + id.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("Common.Edit")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})